angular.module 'zc.projects'

.directive 'zcIncentiveCode', ($translate) ->
  restrict: 'E'
  scope:
    incentive: '='
  template: """
            <span ng-class="codeClass">{{text}}</span>
            <i tooltip="{{tooltipText}}" class="fa fa-exclamation-circle" ng-class="tooltipClass" ng-if="tooltipText"></i>
            """
  link: (scope, element, attrs) ->
    if scope.incentive.incentive_type == 'coupon_code'
      scope.codeClass = ''
      scope.text = scope.incentive.coupon_code
    else if scope.incentive.incentive_type == 'unique_coupon_code'
      scope.codeClass = 'unique_coupon'
      scope.text = $translate.instant('projectsIncentives.incentiveCode.yuniikukuupon_houshiki')



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.incentives/incentive_code.directive.coffee